import { isAllowedCoverImageType } from './cover-image-process.js';

const AVATAR_SIZE = 400;

function randomSeed() {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * 仅使用可明确商用的来源，不用真人肖像库（如 pravatar）。
 * - DiceBear：程序生成插画，MIT
 * - Lorem Picsum：Unsplash 照片，Unsplash License 允许商用
 * - RoboHash：程序生成机器人头像，专供头像使用
 */
const RANDOM_AVATAR_SOURCES = [
  {
    id: 'dicebear',
    buildUrl: () =>
      `https://api.dicebear.com/9.x/adventurer/png?seed=${encodeURIComponent(randomSeed())}&size=${AVATAR_SIZE}`,
  },
  {
    id: 'picsum',
    buildUrl: () => `https://picsum.photos/${AVATAR_SIZE}/${AVATAR_SIZE}?random=${randomSeed()}`,
  },
  {
    id: 'robohash',
    buildUrl: () =>
      `https://robohash.org/${encodeURIComponent(randomSeed())}.png?size=${AVATAR_SIZE}x${AVATAR_SIZE}&set=set1`,
  },
];

function shuffle(list) {
  const next = list.slice();
  for (let i = next.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [next[i], next[j]] = [next[j], next[i]];
  }
  return next;
}

function resolveImageType(blob) {
  const type = String(blob?.type ?? '').toLowerCase();
  if (isAllowedCoverImageType(type)) return type;
  if (type.startsWith('image/')) return 'image/png';
  if (blob?.size > 0) return 'image/jpeg';
  return '';
}

async function fetchAvatarFile(url) {
  const res = await fetch(url, { mode: 'cors' });
  if (!res.ok) {
    throw new Error('RANDOM_AVATAR_FETCH_FAILED');
  }
  const blob = await res.blob();
  const type = resolveImageType(blob);
  if (!type) {
    throw new Error('RANDOM_AVATAR_TYPE');
  }
  const ext = type === 'image/png' ? 'png' : 'jpg';
  return new File([blob], `random-avatar.${ext}`, { type, lastModified: Date.now() });
}

export async function fetchRandomAvatarFile() {
  const sources = shuffle(RANDOM_AVATAR_SOURCES);
  let lastError;
  for (const source of sources) {
    try {
      return await fetchAvatarFile(source.buildUrl());
    } catch (err) {
      lastError = err;
    }
  }
  throw lastError || new Error('RANDOM_AVATAR_FETCH_FAILED');
}

export async function fetchRandomAvatarFiles(count = 10) {
  const size = Math.max(1, Number(count) || 10);
  const results = await Promise.allSettled(
    Array.from({ length: size }, () => fetchRandomAvatarFile())
  );
  const files = results.filter((row) => row.status === 'fulfilled').map((row) => row.value);
  if (!files.length) {
    throw new Error('RANDOM_AVATAR_FETCH_FAILED');
  }
  return files;
}
